import {Injectable, TemplateRef} from '@angular/core';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {Modal} from '@shared/modules/modal/interfaces/modal.interface';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private _onHiddenSubscription: Subscription = null;
  private _onCloseData: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public bsModalRefs: BsModalRef[] = [];

  constructor(private modalService: BsModalService) {}

  private getDefaultConfig(): ModalOptions {
    return {
      backdrop: true,
      keyboard: true,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered pfa-modal'
    };
  }

  private setOnHiddenListener(): void {
    this._onHiddenSubscription = new Subscription();
    this._onHiddenSubscription = this.modalService.onHidden.subscribe((dismissReason) => {
      // Jeżeli null to oznacza, że modal został zamknięty świadomie poprzez metodę .hide()
      // Jeżeli `backdrop-click`, `esc`, oznacza, że został anulowany. Więcej w dokumentacji biblioteki ngx-bootstrap.
      if (dismissReason !== null) {
        this.removeLastBsModalRef(false);
      }

      if (this.bsModalRefs.length === 0) {
        this._onHiddenSubscription.unsubscribe();
        this._onHiddenSubscription = null;
      }
    });
  }

  public show<T>(content: string | TemplateRef<any> | any, config: ModalOptions = {}): Observable<Modal<T>> {
    const modalConfig: ModalOptions = {
      ...this.getDefaultConfig(),
      ...config,
    };

    if (!this._onHiddenSubscription) {
      this.setOnHiddenListener();
    }

    this.bsModalRefs.push(this.modalService.show(content, modalConfig));
    return this.getCloseData$<T>();
  }

  public close<T>(data: Modal<T> = {} as Modal<T>): void {
    this.setCloseData(data);

    this.removeLastBsModalRef(true);
    this._onCloseData = new BehaviorSubject<any>({});
  }

  public removeLastBsModalRef(hide: boolean): void {
    const lastIndex = this.bsModalRefs.length - 1;
    if (hide) {
      this.bsModalRefs[lastIndex].hide();
    }
    this.bsModalRefs.splice(lastIndex, 1);
  }

  public confirmation(component: any, message?: string, yes?: string, no?: string, warning?: string): Observable<Modal<null>> {
    return this.show(component, {
      initialState: { yes, no, message, warning },
      class: 'modal-sm modal-dialog-centered',
    });
  }

  public setCloseData<T>(value: T): void {
    this._onCloseData.next(value);
  }

  public getCloseData<T>(): Modal<T> {
    return this._onCloseData.getValue();
  }

  public getCloseData$<T>(): Observable<Modal<T>> {
    return this._onCloseData.asObservable();
  }
}
